import React from "react";
import { useTranslation } from "react-i18next";
import "./LogoutComplete.css";

const LogoutComplete: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section className="logout-complete" role="status" aria-live="polite">
      <span className="logout-complete__icon" aria-hidden="true">✓</span>
      <h1>{t("personalData.activeDevices.status.loggedOut", { defaultValue: "Logged out" })}</h1>
    </section>
  );
};

export default LogoutComplete;
